export default __webpack_public_path__ + "static/media/multibanco.2c674e43.png";